import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

const ImageSlider = ({ images, type }: any) => {
  const navigate = useNavigate();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(true);

  // 링크이동
  const smartStorePage = () => {
    window.open("https://smartstore.naver.com/throo", "_blank");
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setIsTransitioning(true);
      setCurrentIndex((prevIndex) => prevIndex + 1);
    }, 5000);

    return () => clearInterval(interval);
  }, [images.length]);

  useEffect(() => {
    if (currentIndex === images.length) {
      setTimeout(() => {
        setIsTransitioning(false);
        setCurrentIndex(0);
      }, 1000);
    }
  }, [currentIndex, images.length]);
  return (
    <Style>
      <div className="slider">
        <div
          className={`slides ${isTransitioning ? "transition" : ""}`}
          style={{ transform: `translateX(${-currentIndex * 100}%)` }}
        >
          {images &&
            images.length > 0 &&
            images.concat(images[0]).map((image: any, index: number) => (
              <div className="slide" key={index}>
                <img src={image.src} alt={`Slide ${index + 1}`} />
                {type === "buttonTrue" && (
                  <div className="buttonWrap webView">
                    <button
                      onClick={() => navigate("/contact")}
                      style={{
                        borderColor: `${image.borderColor}`,
                        color: `${image.color}`,
                      }}
                    >
                      지금 상담받기
                      <img
                        src={image.svgSrc}
                        alt="비하인드 상담받기 페이지로 가기"
                      />
                    </button>
                    <button
                      onClick={smartStorePage}
                      style={{
                        borderColor: `${image.borderColor}`,
                        color: `${image.color}`,
                      }}
                    >
                      바로 구매하기
                      <img
                        src={image.svgSrc}
                        alt="비하인드 바로 구매하기 버튼"
                      />
                    </button>
                  </div>
                )}
              </div>
            ))}
        </div>
      </div>
    </Style>
  );
};

export default ImageSlider;

const Style = styled.div`
  .slider {
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: relative;
  }

  .slides {
    display: flex;
  }

  .transition {
    transition: transform 1s ease-in-out;
  }

  .slide {
    flex: 1;
    min-width: 100%;
    box-sizing: border-box;
  }

  .slide img {
    width: 100%;
    height: 100%;
  }
`;
